import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useAppContext } from "../../../_context";
import BenefitsCard from "./BenefitsCard";
import PerkEvents from "../../Icons/Perks/PerkEvents.svg";
import PerkFlexible from "../../Icons/Perks/PerkFlexible.svg";
import PerkLove from "../../Icons/Perks/PerkLove.svg";
import PerkMentoring from "../../Icons/Perks/PerkMentoring.svg";
import PerkRemote from "../../Icons/Perks/PerkRemote.svg";
import PerkShares from "../../Icons/Perks/PerkShares.svg";

const Benefits = () => {
  const [{ tx }] = useAppContext();
  const benefits = [
    {
      icon: PerkFlexible,
      title: tx["Flexible working hours"],
      description:
        tx[
          "Our team members manage their own schedule, so you can flex your work to fit in with your lifestyle."
        ],
    },
    {
      icon: PerkRemote,
      title: tx["Work from anywhere"],
      description:
        tx[
          "Remote working is standard at RacketPal, because geography shouldn't stand between us and a stellar team."
        ],
    },
    {
      icon: PerkMentoring,
      title: tx["Buddy mentoring"],
      description:
        tx[
          "We partner new joiners with experienced members of the RacketPal team so everyone has a buddy to help them succeed."
        ],
    },
    {
      icon: PerkShares,
      title: tx["Own a piece of the pie"],
      description:
        tx[
          "Because everyone in the team is part of our success, we offer share options to every member of the team."
        ],
    },
    {
      icon: PerkEvents,
      title: tx["Quarterly team events"],
      description:
        tx[
          "It can be strange never meeting the people you work with in person, so we organise quarterly get-togethers for the whole team."
        ],
    },
    {
      icon: PerkLove,
      title: tx["Influence beyond your role"],
      description:
        tx[
          "By joining us in the early stages of an exciting journey,  you can help us shape all aspects of RacketPal and grow with the business."
        ],
    },
  ];

  return (
    <section className="section-padding-y">
      <Container>
        <Row>
          {benefits.map((benefit, index) => {
            return <BenefitsCard key={index} benefit={benefit} />;
          })}
        </Row>
      </Container>
    </section>
  );
};

export default Benefits;
